import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Tooltip from '../components/Tooltip'
import Checkbox from '../components/Checkbox'
import GlyphDots from '../icons/GlyphDots'

const Will = ({
  index,
  userAddr,
  userId,
  amount,
  priceForToken,
  indicatedTime,
  owner,
  onClickForManipulation
}) => {
  const dotsWrapper = useRef()

  var className = 'flex items-center sans-serif';
  const styles = { height: 36, background: '#ffffff', overflow: 'hidden' }
  /*const styles = index % 2 === 0
    ? { height: 74, background: '#ffffff', overflow: 'hidden' }
    : { height: 74, background: '#f7f7f7', overflow: 'hidden' }*/

  const timeVariance = 10800;
  const indicatedTimeStr = new Date(indicatedTime * 1000).toLocaleString("ja");

  const decToHex =str => {
    var dec = str.toString().split(''),
      sum = [],
      hex = [],
      i,
      s;
    while (dec.length) {
      s = 1 * dec.shift();
      for (i = 0; s || i < sum.length; i++) {
        s += (sum[i] || 0) * 10;
        sum[i] = s % 16;
        s = (s - sum[i]) / 16;
      }
    }
    while (sum.length) {
      hex.push(sum.pop().toString(16));
    }
    return "0x" + hex.join('');
  }

  return (
    <div className={className} style={styles}>
      <button onClick={() => onClickForManipulation(owner, userAddr, userId, amount, priceForToken, indicatedTime)} className='flex-grow-1 w-30 tc f5 gray truncate'>{userAddr}</button>
      <button onClick={() => onClickForManipulation(owner, userAddr, userId, amount, priceForToken, indicatedTime)} className='flex-grow-1 w-20 tc f5 gray truncate'>{amount}</button>
      <button onClick={() => onClickForManipulation(owner, userAddr, userId, amount, priceForToken, indicatedTime)} className='flex-grow-1 w-20 tc f5 gray truncate'>{priceForToken}</button>
      <button onClick={() => onClickForManipulation(owner, userAddr, userId, amount, priceForToken, indicatedTime)} className='flex-grow-1 w-20 tc f5 gray truncate'>{indicatedTimeStr}</button>
    </div>
  )
}

export default Will;
